import { matchPath } from 'react-router-dom';

import { apiConfig } from '@yandex-int/k-common/client/api/config';

export const getIsInStudentStatsBundle = (pathname: string) => {
    const urls = apiConfig.getStaticUrls();
    return matchPath(pathname, { path: urls.labStudentSubject, exact: false });
};
